module.exports = __webpack_public_path__ + "images/payrollpanda-logo-md.png";


//////////////////
// WEBPACK FOOTER
// ./images/payrollpanda-logo-md.png
// module id = 1123
// module chunks = 1